import { FromJsonParser } from "../../../../shared/types/parser";

export interface SipUser {
    extension: string;
    username: string;
    password: string;
    outboundProxy: string;
    sipDomain: string;
    sessionId: string;
}

export interface SipUserParser extends FromJsonParser<SipUser> {}

export const sipUserParser: SipUserParser = {
    fromJson: (json) => {
        return {
            extension: json['extension'] ?? '',
            username: json['username'] ?? '',
            password: json['password'] ?? '',
            outboundProxy: json['outboundProxy'] ?? '',
            sipDomain: json['sipDomain'] ?? '',
            sessionId: json['sessionId'] ?? '',
        }
    }
}

export interface SipUserFormData {
    extension: string;
    username: string;
    password: string;
    outboundProxy: string;
    sipDomain: string;
    sessionId: string;
}

export interface SipUserFormDataParser {
    empty(): SipUserFormData;
    fromSipUser(sipUser: SipUser): SipUserFormData;
}

export const sipUserFormDataParser: SipUserFormDataParser = {
    empty: () => {
        return {
            extension: '',
            username: '',
            password: '',
            outboundProxy: '',
            sipDomain: '',
            sessionId: '',
        }
    },
    fromSipUser: (sipUser) => {
        return {
            extension: sipUser.extension,
            username: sipUser.username,
            password: sipUser.password,
            outboundProxy: sipUser.outboundProxy,
            sipDomain: sipUser.sipDomain,
            sessionId: sipUser.sessionId,
        }
    }
}
